export const categories = [
  {
    key: "all",
    label: "全部影视",
    type: "all",
    icon: "ri-gallery-view-2",
    accent: "primary",
    description: "汇集站内全部影视资源，覆盖电影、电视剧、动漫、综艺与纪录片，随时找到你想看的那一部。"
  },
  {
    key: "movie",
    label: "电影",
    type: "电影",
    icon: "ri-film-line",
    accent: "accent",
    description: "院线大片与高分佳作齐聚，从科幻悬疑到温情文艺，总有一部适合你的夜晚。"
  },
  {
    key: "tv",
    label: "电视剧",
    type: "电视剧",
    icon: "ri-live-line",
    accent: "secondary",
    description: "热播剧集与经典系列持续更新，悬疑、都市、年代题材应有尽有。"
  },
  {
    key: "anime",
    label: "动漫",
    type: "动漫",
    icon: "ri-brush-line",
    accent: "accent",
    description: "国风奇幻与推理冒险并重，画面与故事同样出色的动漫作品合集。"
  },
  {
    key: "variety",
    label: "综艺",
    type: "综艺",
    icon: "ri-mic-line",
    accent: "secondary",
    description: "美食、文化、真人秀，轻松又有内容的综艺节目，适合下饭和放松。"
  },
  {
    key: "documentary",
    label: "纪录片",
    type: "纪录片",
    icon: "ri-earth-line",
    accent: "primary",
    description: "自然、人文与地理纪录片精选，用真实影像拓展你看世界的边界。"
  }
];

export const filterOptions = {
  types: ["全部", "电影", "电视剧", "动漫", "综艺", "纪录片"],
  regions: ["全部", "中国大陆", "中国香港", "日本", "韩国", "美国", "英国"],
  years: ["全部", "2024", "2023", "2022"],
  ratings: ["全部", "9分以上", "8分以上", "7分以上"]
};

export const heroSlides = [
  {
    id: "deep-sea-echo",
    badge: "本周热映",
    title: "深海回声",
    subtitle: "有些秘密，沉在比黑暗更深的地方。",
    tags: ["科幻", "悬疑", "冒险"],
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20underwater%20seascape%20of%20a%20deep%20ocean%20trench%20with%20a%20lone%20diver%20silhouette%20surrounded%20by%20glowing%20bioluminescent%20particles%2C%20shafts%20of%20light%20piercing%20the%20dark%20water%2C%20deep%20navy%20and%20teal%20tones%20with%20subtle%20warm%20orange%20glow%2C%20atmospheric&width=1600&height=900&seq=hero-01&orientation=landscape"
  },
  {
    id: "sea-of-stars",
    badge: "口碑爆棚",
    title: "星海纪年",
    subtitle: "人类迈出的一小步，需要一整个世纪来偿还。",
    tags: ["科幻", "史诗", "剧情"],
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20space%20scene%20of%20a%20giant%20ringed%20planet%20with%20a%20lone%20starship%20sailing%20through%20a%20swirling%20nebula%2C%20distant%20stars%20and%20cosmic%20dust%2C%20deep%20navy%20and%20indigo%20tones%20with%20warm%20orange%20highlights%2C%20epic%20and%20awe%20inspiring&width=1600&height=900&seq=hero-02&orientation=landscape"
  },
  {
    id: "end-of-long-night",
    badge: "新剧上线",
    title: "长夜将尽",
    subtitle: "黑夜最长的时刻，往往是黎明前。",
    tags: ["悬疑", "犯罪", "剧情"],
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20rainy%20city%20street%20at%20night%20with%20towering%20buildings%2C%20wet%20asphalt%20reflecting%20warm%20streetlights%2C%20a%20lone%20figure%20under%20an%20umbrella%2C%20deep%20navy%20and%20charcoal%20tones%20with%20orange%20glow%2C%20moody%20noir&width=1600&height=900&seq=hero-03&orientation=landscape"
  },
  {
    id: "mountains-and-seas",
    badge: "国风推荐",
    title: "山海拾遗录",
    subtitle: "每一只异兽，都记得一个被遗忘的名字。",
    tags: ["国风", "奇幻", "冒险"],
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20eastern%20fantasy%20landscape%20of%20floating%20mythical%20mountains%20above%20a%20sea%20of%20clouds%2C%20flying%20cranes%20and%20ancient%20pavilions%2C%20deep%20navy%20and%20jade%20teal%20tones%20with%20warm%20orange%20sun%2C%20ethereal%20ink%20painting%20style&width=1600&height=900&seq=hero-04&orientation=landscape"
  }
];

export const siteInfo = {
  name: "秘密影院",
  slogan: "专业电影电视剧免费在线观看平台",
  intro:
    "秘密影院是一个专注于影视内容展示与推荐的在线平台。我们聚合电影、电视剧、动漫、综艺与纪录片等丰富资源，通过清晰的分类、便捷的搜索和用心的专题推荐，帮助每一位观众更快找到想看的作品。",
  scope:
    "平台内容覆盖院线电影、热播剧集、国风动漫、优质综艺与自然人文纪录片等多种类型，持续更新最新影视资讯，力求让查找与浏览都轻松顺畅。",
  email: "hello@secretcinema-demo.com",
  brandNote: "本站为影视内容展示与推荐演示平台。"
};